import LoginInfoSheet from '@molecules/LoginInfoSheet';
import navigationConstants from '@navigation/navigationConstants';
import { showErrors } from '@screens/GGOTP/otpUtils';
import { showErrorBottomSheet } from '@utils/utils';
import React from 'react';

// Define the type for the info modal content
interface InfoModalType {
  visible: boolean;
  data: any;
  errorCode: string;
}

// interface ShouldShowLoginInfoSheetProps {
//   onCloseModal: () => void;
//   infoModal: InfoModalType;
// }

export function shouldShowLoginInfoSheet(onCloseModal: () => void, infoModal: InfoModalType): React.JSX.Element | null {
  if (infoModal.visible) {
    return <LoginInfoSheet onPressPrimary={onCloseModal} loginInfo={infoModal} onClose={onCloseModal} />;
  }
  return null;
}

interface ShouldRenderErrorProps {
  isError: boolean;
  error: any;
  setIsLoadingSMS: (val: boolean) => void;
  setIsLoadingWhatsapp: (val: boolean) => void;
  setLoading: (val: boolean) => void;
  setErrTxtMsg: (msg: string) => void;
  t: (key: string) => string;
  mobileNumber: string;
  setInfoModal: (val: any) => void;
  setDisableOTP: (val: boolean) => void;
}

export function shouldRenderError({
  isError,
  error,
  setIsLoadingSMS,
  setIsLoadingWhatsapp,
  setLoading,
  setErrTxtMsg,
  t,
  mobileNumber,
  setInfoModal,
  setDisableOTP,
}: ShouldRenderErrorProps): void {
  if (isError && error) {
    setIsLoadingSMS(false);
    setIsLoadingWhatsapp(false);

    if (error[0] === 'GG-OTP-08') {
      showErrors(true, error, setLoading, setErrTxtMsg, t, mobileNumber, false, setDisableOTP);
    } else {
      showErrorBottomSheet(setIsLoadingSMS, setIsLoadingWhatsapp, mobileNumber, error[0], setInfoModal);
    }
  }
}

interface ShouldRenderOnSuccessProps {
  LoginData: any;
  isSuccess: boolean;
  setLoginData: (data: any) => void;
  setIsLoadingSMS: (val: boolean) => void;
  setIsLoadingWhatsapp: (val: boolean) => void;
  fromLogin: boolean;
  navigation: {
    navigate: (screen: string) => void;
  };
  setInfoModal: React.Dispatch<React.SetStateAction<InfoModalType>>;
}

export function shouldRenderOnSuccess({
  LoginData,
  isSuccess,
  setLoginData,
  setIsLoadingSMS,
  setIsLoadingWhatsapp,
  fromLogin,
  navigation,
  setInfoModal,
}: ShouldRenderOnSuccessProps): void {
  if (LoginData && isSuccess) {
    setLoginData(LoginData);
    setIsLoadingSMS(false);
    setIsLoadingWhatsapp(false);

    if (fromLogin) {
      navigation.navigate(navigationConstants.OTP);
    } else {
      setInfoModal(prevState => ({ ...prevState, visible: true }));
    }
  }
}
